import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Switch,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  FormControl,
  MenuItem,
  InputLabel,
  Select,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../../../theme";
import Header from "../../../Dashboard/Header";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const PREFERENCE_KEY = "infiniteAppUserPreferences";

export default function ApprovalModuleUsers() {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const token = localStorage.getItem("token");
  const cmpid = localStorage.getItem("cmpid");

  const [rows, setRows] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentVoucher, setCurrentVoucher] = useState([]);
  const [Users, setUsers] = useState([]);
  const [vchtypewiseconfig, setvchtypewiseconfig] = useState([]);
  const [pageSize, setPageSize] = useState(20); // Increased default page size

  // Load saved user preferences from localStorage with compact defaults
  const saved = localStorage.getItem(PREFERENCE_KEY);
  const preferences = saved
    ? JSON.parse(saved)
    : {
        rowHeight: 28, // Reduced from 40 to 28
        fontFamily: "Source Sans Pro",
        fontSize: 13, // Reduced from 16 to 13
        tableAlign: "center",
      };

  //  Button toggle change page ========================

  const [isVoucher, setIsVoucher] = useState();

  const handleToggle = () => {
    setIsVoucher(!isVoucher);
    fetchMasterTypes();
  };

  const handleToggleStk = () => {
    navigate("/Infinite/StockItemConfig");
  };

  useEffect(() => {
    fetchMasterTypes();
    fetchUserList();
    setIsVoucher(true);
  }, []);

  /* ───────── fetch voucher types ───────── */

  const fetchMasterTypes = async () => {
    const MasterBody = {
      cmpId: cmpid,
      type: isVoucher ? "ledger" : "voucher",
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/approvalModule/displayMasterTypesConfig`,
        MasterBody,
        { headers: { Authorization: token } }
      );
      const vchTypeArray = response?.data?.typeMap?.["0"]?.type || [];
      setRows(vchTypeArray);
    } catch (err) {
      if (err.response.status === 404) {
        alert("No Masters Added");
      }
    }
  };

  const fetchUserList = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/userAPI/list`,
        {},
        { headers: { Authorization: token } }
      );

      const rawUserData = Object.values(response.data.users || {});

      setUsers(rawUserData);
    } catch (error) {
      console.log(error);
    }
  };

  /* ───────── DataGrid columns ───────── */

  const columns = [
    {
      field: "typeName",
      headerName: isVoucher ? "Voucher Type Name" : "Group Name",
      flex: 1,
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      sortable: false,
    },
    {
      field: "config",
      headerName: "Config",
      flex: 1,
      sortable: false,
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      renderCell: (params) => (
        <Button
          variant="contained"
          size="small"
          sx={{
            backgroundColor: "#EFE17C",
            color: "#000000",
            height: preferences.rowHeight - 8, // Reduced from -5 to -8
            fontSize: 12, // Reduced from 14 to 12
            padding: "4px 12px", // Reduced padding
            fontWeight: "bold",
            minWidth: "auto", // Allow button to shrink
            "&:hover": {
              backgroundColor: "#E6D669",
              color: "#000000",
            },
          }}
          onClick={() => handleVoucherClick(params.row)}
        >
          Add
        </Button>
      ),
    },
  ];

  //====================================================

  const handleVoucherClick = async (rowData) => {
    setCurrentVoucher(rowData);
    setOpenDialog(true);

    if (rowData && Object.keys(rowData).length > 0) {
      await ConfigData(rowData);
      await ConfigVchDet(rowData);
    }
  };

  /* ───────── Single vch details ───────── */

  const [vchdata, setvchdata] = useState([]);

  const ConfigVchDet = async (voucher) => {
    const endpoint = isVoucher ? "voucherType" : "group";

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/display/${endpoint}`,
        { cmpid },
        { headers: { Authorization: token } }
      );

      if (isVoucher) {
        const vchTypeMap = response?.data?.vchTypeMap?.[0]?.vchType || [];
        const selected = vchTypeMap.find(
          (v) => v.vchTypeName === voucher?.typeName
        );

        if (selected?.approvalConfig?.[0]) {
          setvchdata(selected.approvalConfig[0]);
        }
      } else {
        const groupMap = response?.data?.groupMap?.[0]?.group || [];
        const selected = groupMap.find(
          (v) => v.groupName === voucher?.typeName
        );
        if (selected?.approvalConfig?.[0]) {
          setvchdata(selected.approvalConfig[0]);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  /* ───────── show Vch config Data  ───────── */

  const ConfigData = async (voucher) => {
    const UserConfig = {
      cmpid: cmpid,
      type: voucher.type,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/approvalModule/userconfig/list`,
        UserConfig,
        { headers: { Authorization: token } }
      );

      const configData = Object.values(response.data);
      let updatedUsers = [];

      Users.forEach((user) => {
        const matchingConfig = configData.find(
          (config) =>
            config.user_id === user.user_Id &&
            config.type_name === voucher.typeName
        );

        let temp;

        if (matchingConfig) {
          temp = {
            user_Name: user.user_Name,
            firstLevel:
              matchingConfig.permission_Level_1 === "1" ? true : false,
            secondLevel:
              matchingConfig.permission_Level_2 === "1" ? true : false,
            thirdLevel:
              matchingConfig.permission_Level_3 === "1" ? true : false,
            amountFrom: matchingConfig.amt_From || 0,
            amountTo: matchingConfig.amt_To || 0,
            user_Id: user.user_Id,
            amtCondition: matchingConfig.amtCondition,
          };
        } else {
          temp = {
            user_Name: user.user_Name,
            firstLevel: false,
            secondLevel: false,
            thirdLevel: false,
            amountFrom: 0,
            amountTo: 0,
            user_Id: user.user_Id,
            amtCondition: "",
          };
        }

        updatedUsers.push(temp);
      });

      setvchtypewiseconfig(updatedUsers);
    } catch (error) {
      console.log(error);
    }
  };

  /* ───────── Toggle / Input handlers ───────── */

  const handleUserToggle = (userId, key) => {
    setvchtypewiseconfig((prevConfig) =>
      prevConfig.map((user) =>
        user.user_Id === userId ? { ...user, [key]: !user[key] } : user
      )
    );
  };

  const handleUserInputChange = (userId, key, value) => {
    setvchtypewiseconfig((prevConfig) =>
      prevConfig.map((user) =>
        user.user_Id === userId ? { ...user, [key]: value } : user
      )
    );
  };

  const handleAmtChange = (userId, key, value) => {
    setvchtypewiseconfig((prevConfig) =>
      prevConfig.map((user) =>
        user.user_Id === userId ? { ...user, [key]: value } : user
      )
    );
  };

  /* ───────── Submit config ───────── */

  const handleFormSubmit = async () => {
    let configData = [];

    if (isVoucher) {
      configData = vchtypewiseconfig.map((user) => {
        const config = {
          userid: user.user_Id,
          cmpid: cmpid,
          type: "Voucher",
          Typename: currentVoucher.typeName,
        };

        if (vchdata.level >= 1)
          config.permissionLevel1 = user.firstLevel ? 1 : 0;
        if (vchdata.level >= 2)
          config.permissionLevel2 = user.secondLevel ? 1 : 0;
        if (vchdata.level >= 3)
          config.permissionLevel3 = user.thirdLevel ? 1 : 0;

        if (vchdata.isAmt === 1) {
          config.amtFrom = user.amountFrom;
          config.amtTo = user.amountTo;
          config.amtCondition = user.amtCondition;
        }

        return config;
      });
    } else {
      configData = vchtypewiseconfig.map((user) => {
        const config = {
          userid: user.user_Id,
          cmpid: cmpid,
          type: "ledger",
          Typename: currentVoucher.typeName,
        };

        if (vchdata.level >= 1)
          config.permissionLevel1 = user.firstLevel ? 1 : 0;

        if (vchdata.level >= 2)
          config.permissionLevel2 = user.secondLevel ? 1 : 0;

        return config;
      });
    }

    // console.log("config user Data",configData)
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/approvalModule/userconfig/create`,
        configData,
        { headers: { Authorization: token } }
      );
      Swal.fire({
        title: "success!",
        text: "Approval Users Configuration Submitted Successfully",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#EFE17C",
        width: "300px",
        padding: "1em",
        customClass: {
          popup: "small-alert",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "Error Submitting Approval Users Configuration!",
        icon: "error",
        confirmButtonText: "Close",
        confirmButtonColor: "#d32f2f",
        width: "300px",
        padding: "1em",
        customClass: {
          popup: "small-alert",
        },
      });
    }
    setOpenDialog(false);
  };

  // ================================================

  return (
    <>
      <Box mt="70px" ml="0px" mr="20px">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Header
            title={
              isVoucher ? "Voucher Type Configuration" : "Group Configuration"
            }
            subtitle={
              isVoucher
                ? "Approval Users Voucher Configurations"
                : "Approval Users Group Configurations"
            }
          />
          <Box display="flex" gap={2}>
            <Button
              variant="contained"
              size="small"
              onClick={handleToggleStk}
              sx={{
                backgroundColor: "#EFE17C",
                color: "#000000",
                height: "35px",
                minHeight: "35px",
                "&:hover": {
                  backgroundColor: "#E6D669",
                  color: "#000000",
                },
              }}
            >
              Stock Item Config
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={handleToggle}
              sx={{
                backgroundColor: "#EFE17C",
                color: "#000000",
                height: "35px",
                minHeight: "35px",
                "&:hover": {
                  backgroundColor: "#E6D669",
                  color: "#000000",
                },
              }}
            >
              {isVoucher ? "Ledger Config" : "Voucher Config"}
            </Button>
          </Box>
        </Box>

        <Box
          height="80vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
              cursor: "pointer",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: "none",
              color: colors.primary[120],
              cursor: "default",
            },
            "& .MuiDataGrid-columnHeader": {
              padding: "0 !important",
            },
            "& .MuiDataGrid-columnHeader:focus": {
              outline: "none",
              boxShadow: "none",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              outline: "none",
              boxShadow: "none",
            },
            "& .MuiDataGrid-columnHeader:focus-visible": {
              outline: "none",
              boxShadow: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
              color: colors.primary[150],
            },
            // ✅ Zoom on hover using a class
            "& .AppUserzoom-row:hover": {
              transform: "scale(1.01)",
              transition: "transform 0.2s ease-in-out",
              zIndex: 1,
              backgroundColor: colors.blueAccent[900],
            },
          }}
        >
          <DataGrid
            rows={rows}
            columns={columns}
            getRowId={(row) => row.typeName}
            pageSize={pageSize}
            getRowClassName={() => "AppUserzoom-row"}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 2100]}
            disableSelectionOnClick
            disableColumnMenu
            pagination
            rowHeight={30}
            headerHeight={30}
            componentsProps={{
              footer: {
                sx: {
                  height: 30,
                  minHeight: 30,
                },
              },
            }}
          />
        </Box>

        <Dialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 2,
              maxHeight: "90vh",
            },
          }}
        >
          <DialogTitle
            sx={{
              fontSize: "1.25rem",
              fontWeight: 700,
              display: "flex",
              justifyContent: "space-between",
              backgroundColor: "#EFE17C",
              color: "#000000",
              padding: "8px 16px",
            }}
          >
            Add Config for {currentVoucher.type}
          </DialogTitle>

          <DialogContent sx={{ backgroundColor: "#fafafa", padding: 1 }}>
            {" "}
            {/* Reduced padding */}
            <Box sx={{ maxHeight: "60vh", overflow: "auto" }}>
              {" "}
              {/* Added scroll for large tables */}
              <Table size="small">
                {" "}
                {/* Added size="small" prop */}
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        color: "#000000",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                        minWidth: 120, // Reduced width
                        fontSize: "0.8125rem", // Reduced font size
                        padding: "8px 12px", // Reduced padding
                      }}
                    >
                      User Name
                    </TableCell>

                    {isVoucher
                      ? ["First Level", "Second Level", "Third Level"]
                          .slice(0, vchdata.level)
                          .map((label, index) => (
                            <TableCell
                              key={index}
                              sx={{
                                color: "#000000",
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                                minWidth: 100, // Reduced width
                                fontSize: "0.8125rem", // Reduced font size
                                padding: "8px 12px", // Reduced padding
                              }}
                            >
                              {label}
                            </TableCell>
                          ))
                      : ["First Level", "Second Level"]
                          .slice(0, vchdata.level)
                          .map((label, index) => (
                            <TableCell
                              key={index}
                              sx={{
                                color: "#000000",
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                                minWidth: 100,
                                fontSize: "0.8125rem",
                                padding: "8px 12px",
                              }}
                            >
                              {label}
                            </TableCell>
                          ))}

                    {vchdata.isAmt === 1 && isVoucher && (
                      <>
                        <TableCell
                          sx={{
                            color: "#000000",
                            fontWeight: "bold",
                            whiteSpace: "nowrap",
                            minWidth: 120, // Reduced width
                            fontSize: "0.8125rem", // Reduced font size
                            padding: "8px 12px", // Reduced padding
                          }}
                        >
                          Amount From
                        </TableCell>
                        <TableCell
                          sx={{
                            color: "#000000",
                            fontWeight: "bold",
                            whiteSpace: "nowrap",
                            minWidth: 140, // Reduced width
                            fontSize: "0.8125rem", // Reduced font size
                            padding: "8px 12px", // Reduced padding
                          }}
                        >
                          Amount Condition
                        </TableCell>
                        <TableCell
                          sx={{
                            color: "#000000",
                            fontWeight: "bold",
                            whiteSpace: "nowrap",
                            minWidth: 120, // Reduced width
                            fontSize: "0.8125rem", // Reduced font size
                            padding: "8px 12px", // Reduced padding
                          }}
                        >
                          Amount To
                        </TableCell>
                      </>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {vchtypewiseconfig.map((u) => (
                    <TableRow
                      key={u.user_Id}
                      sx={{
                        "&:nth-of-type(even)": { backgroundColor: "#f9f9f9" },
                      }}
                    >
                      <TableCell
                        sx={{
                          fontWeight: "medium",
                          fontSize: "0.8125rem", // Reduced font size
                          padding: "6px 12px", // Reduced padding
                          lineHeight: 1.2, // Tighter line height
                        }}
                      >
                        {u.user_Name}
                      </TableCell>
                      {isVoucher
                        ? ["firstLevel", "secondLevel", "thirdLevel"]
                            .slice(0, vchdata.level)
                            .map((key) => (
                              <TableCell key={key} sx={{ padding: "4px 8px" }}>
                                {" "}
                                {/* Reduced padding */}
                                <Switch
                                  size="small" // Added small switch
                                  checked={u[key] || false}
                                  onChange={() =>
                                    handleUserToggle(u.user_Id, key)
                                  }
                                  color="primary"
                                />
                              </TableCell>
                            ))
                        : ["firstLevel", "secondLevel"]
                            .slice(0, vchdata.level)
                            .map((key) => (
                              <TableCell key={key} sx={{ padding: "4px 8px" }}>
                                {" "}
                                {/* Reduced padding */}
                                <Switch
                                  size="small" // Added small switch
                                  checked={u[key] || false}
                                  onChange={() =>
                                    handleUserToggle(u.user_Id, key)
                                  }
                                  color="primary"
                                />
                              </TableCell>
                            ))}

                      {vchdata.isAmt === 1 && isVoucher && (
                        <>
                          <TableCell sx={{ padding: "4px 8px" }}>
                            {" "}
                            {/* Reduced padding */}
                            <TextField
                              size="small"
                              type="number"
                              value={u.amountFrom}
                              onChange={(e) =>
                                handleUserInputChange(
                                  u.user_Id,
                                  "amountFrom",
                                  e.target.value
                                )
                              }
                              InputProps={{
                                readOnly: u.amtCondition === "Less Than",
                                sx: { fontSize: "0.8125rem" }, // Reduced font size
                              }}
                              helperText={
                                u.amtCondition === "Less Than"
                                  ? "This field will be not consider"
                                  : "Enter amount"
                              }
                              FormHelperTextProps={{
                                style: {
                                  fontSize: "0.75rem", // Reduced helper text size
                                  color:
                                    u.amtCondition === "Less Than"
                                      ? "red"
                                      : "#666666",
                                },
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ padding: "4px 8px", minWidth: 160 }}>
                            {" "}
                            {/* Reduced padding */}
                            <FormControl fullWidth size="small">
                              {" "}
                              {/* Added size="small" */}
                              <InputLabel
                                id="amtCondition"
                                sx={{ fontSize: "0.8125rem" }}
                              >
                                Amount Condition
                              </InputLabel>
                              <Select
                                labelId="amtCondition"
                                label="Amount Condition"
                                value={u.amtCondition}
                                onChange={(e) =>
                                  handleAmtChange(
                                    u.user_Id,
                                    "amtCondition",
                                    e.target.value
                                  )
                                }
                                sx={{ fontSize: "0.8125rem" }} // Reduced font size
                              >
                                <MenuItem
                                  value="Greater Than"
                                  sx={{ fontSize: "0.8125rem" }}
                                >
                                  Greater Than
                                </MenuItem>
                                <MenuItem
                                  value="Less Than"
                                  sx={{ fontSize: "0.8125rem" }}
                                >
                                  Less Than
                                </MenuItem>
                                <MenuItem
                                  value="in between"
                                  sx={{ fontSize: "0.8125rem" }}
                                >
                                  In Between
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </TableCell>
                          <TableCell sx={{ padding: "4px 8px" }}>
                            {" "}
                            {/* Reduced padding */}
                            <TextField
                              size="small"
                              type="number"
                              value={u.amountTo}
                              onChange={(e) => {
                                const value = e.target.value;
                                handleUserInputChange(
                                  u.user_Id,
                                  "amountTo",
                                  value
                                );
                              }}
                              InputProps={{
                                readOnly: u.amtCondition === "Greater Than",
                                sx: { fontSize: "0.8125rem" }, // Reduced font size
                              }}
                              helperText={
                                u.amtCondition === "Greater Than"
                                  ? "This field will be not consider"
                                  : "Enter amount"
                              }
                              FormHelperTextProps={{
                                style: {
                                  fontSize: "0.75rem", // Reduced helper text size
                                  color:
                                    u.amtCondition === "Greater Than"
                                      ? "red"
                                      : "#666666",
                                },
                              }}
                            />
                          </TableCell>
                        </>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </DialogContent>

          <DialogActions
            sx={{
              pb: 1, // Reduced padding
              pt: 1, // Reduced padding
              backgroundColor: "#fafafa",
              padding: "8px 16px", // Reduced padding
            }}
          >
            <Button
              variant="contained"
              size="small" // Added small size
              sx={{
                backgroundColor: "#d32f2f",
                color: "#ffffff",
                fontWeight: "bold",
                fontSize: "0.75rem", // Reduced font size
                padding: "6px 12px", // Reduced padding
                "&:hover": {
                  backgroundColor: "#b71c1c",
                },
              }}
              onClick={() => setOpenDialog(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              size="small" // Added small size
              sx={{
                backgroundColor: "#EFE17C",
                color: "#000000",
                fontWeight: "bold",
                fontSize: "0.75rem", // Reduced font size
                padding: "6px 12px", // Reduced padding
                "&:hover": {
                  backgroundColor: "#E6D669",
                },
              }}
              onClick={handleFormSubmit}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
}
